
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-statistics",
      function () {
        return require("private-next-pages/my-statistics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-statistics"])
      });
    }
  